import { FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core'
import { useUser } from 'components/providers/UserProvider'
import { editUserAttribute } from 'lib/api'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { UserAttribute, UserAttributeName } from 'shared'

export interface AccountSettingSelectProps {
  attribute: UserAttributeName
  options: { name: string; value: string }[]
  onChange?: (value: unknown) => void
  helperText?: string
}

export const AccountSettingSelect = ({
  attribute,
  options,
  onChange,
  helperText,
}: AccountSettingSelectProps): JSX.Element => {
  const { user, setUser } = useUser()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  return (
    <FormControl fullWidth={true}>
      {user && (
        <Select
          onChange={async (e) => {
            try {
              const response = await editUserAttribute(e.target.value as UserAttribute, attribute)
              enqueueSnackbar(t('changesSaved'), {
                variant: 'success',
              })
              setUser({
                ...user,
                ...response,
              })
              onChange?.(response.language)
            } catch (error) {
              enqueueSnackbar(String(error), {
                variant: 'error',
              })
            }
          }}
          // label={t('card.language')}
          value={user[attribute]}
          data-testid={`choose-${attribute}`}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value} style={{ fontSize: '14px' }}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      )}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
